import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/auth';
import { ErrorService } from '@app/pages/error/error.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabManagerService {
  private uniqueTabId = Date.now() + '_' + Math.random();
  private channel = new BroadcastChannel('multi_tab_detection');
  public tabChangeEvent = new BehaviorSubject(undefined as any);
  public detectNewTabs(): void {
    console.log("this.uniqueTabId", this.uniqueTabId);
    // Store the current tab's ID
    let latestTabId = localStorage.getItem('latestTab');
    console.log("latestTabId", latestTabId);
    if(!latestTabId) {
      localStorage.setItem('latestTab', this.uniqueTabId);
    }else {
      this.uniqueTabId = latestTabId;
    }

    // Listen for changes in localStorage
    window.addEventListener('storage', (event) => {
      console.log("[storage] on listener");
      if (event.key === 'latestTab' && event.newValue !== this.uniqueTabId) {
        this.tabChangeEvent.next({logout:true, nextUrl: "/"});
      }
    });

    // Listen for messages from other tabs using BroadcastChannel
    this.channel.onmessage = (event) => {
      console.log("[channel] on message ");
      if (event.data.type === 'NEW_TAB_OPENED' && event.data.id !== this.uniqueTabId) {
        this.tabChangeEvent.next({logout:true, nextUrl: "/"});
      } else {
        this.tabChangeEvent.next({logout:false, nextUrl: "/"});
      }
    };

    // Broadcast to other tabs that a new tab is open
    this.channel.postMessage({ type: 'NEW_TAB_OPENED', id: this.uniqueTabId });
  }

  public postMessage() {
    this.channel.postMessage({ type: 'NEW_TAB_OPENED', id: this.uniqueTabId });
  }
}
